import * as React from 'react';
import * as main from "../../styles/main.module.scss";
import * as target from "./style.module.scss";
export const Target = () => {
  return (
    <section className={target.target}>
      <div className="container">
        <h2 className={`${main.mainTitle} ${target.target__title}`}>Данный курс подходит</h2>
        <ul className={target.target__list}>
          <li className={target.target__item}>
            <img src="https://fs.advance.ru/landing-pages/online/time_management/_target/who-01.png" alt={""}/>
            <p className={target.target__itemText}>Ведущим специалистам</p>
          </li>
          <li className={target.target__item}>
            <img src="https://fs.advance.ru/landing-pages/online/time_management/_target/who-02.png" alt={""}/>
            <p className={target.target__itemText}>Начинающим руководителям</p>
          </li>
          <li className={target.target__item}>
            <img src="https://fs.advance.ru/landing-pages/online/time_management/_target/who-03.png" alt={""}/>
            <p className={target.target__itemText}>Фрилансерам и работающим по свободному графику</p>
          </li>
          <li className={target.target__item}>
            <img src="https://fs.advance.ru/landing-pages/online/time_management/_target/who-04.png" alt={""}/>
            <p className={target.target__itemText}>Cтудентам и учащимся</p>
          </li>
        </ul>
      </div>
    </section>
  );
};
